const FileUploadHistoryApiUrls = {
  GET: `${process.env.REACT_APP_USER_SBCI_URL}/sbci/fileuploadhistory/get`,
  POST: `${process.env.REACT_APP_USER_SBCI_URL}/sbci/fileuploadhistory/create`,
  PUT: `${process.env.REACT_APP_USER_SBCI_URL}/sbci/fileuploadhistory/update`,
  DELETE: `${process.env.REACT_APP_USER_SBCI_URL}/sbci/fileuploadhistory/delete`,
  EXPORT: `${process.env.REACT_APP_USER_SBCI_URL}/sbci/fileuploadhistory/download`,
  DOWNLOAD: `${process.env.REACT_APP_USER_SBCI_URL}/sbci/fileuploadhistory/downloadAttachment`,
};

export default FileUploadHistoryApiUrls
